module.exports = __webpack_public_path__ + "static/img/tj_a9.40efaced.png";